/**
 * Prefix a message with a namespace.
 */
export function formatNamespacedMessage(namespace: string, message: string) {
    return `[${namespace}] ${message}`;
}
